import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { PasswordField } from "@/components/PasswordField";

export default function ChangePassword() {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = () => { setCur(""); setNw(""); };
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      if (r.data?.token) localStorage.setItem("nq_token", r.data.token);
      toast.success("Password changed successfully");
      reset(); setOpen(false);
    } catch (ex) { toast.error(errMsg(ex)); }
    setBusy(false);
  };

  return (
    <>
      <button data-testid="change-password-button" onClick={() => { reset(); setOpen(true); }} className="btn-ghost h-8 w-8 px-0" title="Change password"><KeyRound className="w-3.5 h-3.5" /></button>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 grid place-items-center p-4" data-testid="change-password-modal" onClick={() => setOpen(false)}>
          <form onClick={(e) => e.stopPropagation()} onSubmit={submit} className="w-full max-w-sm panel p-6 rise">
            <h3 className="font-display text-lg font-bold text-white mb-1">Change password</h3>
            <p className="text-xs text-slate-500 mb-4">Enter your current password and choose a new one (min 6 characters).</p>
            <div className="space-y-3">
              <label className="flex flex-col gap-1"><span className="widget-title">Current password</span>
                <PasswordField testid="cp-current-input" value={cur} onChange={(e) => setCur(e.target.value)} required autoComplete="current-password" /></label>
              <label className="flex flex-col gap-1"><span className="widget-title">New password</span>
                <PasswordField testid="cp-new-input" value={nw} onChange={(e) => setNw(e.target.value)} required minLength={6} autoComplete="new-password" /></label>
            </div>
            <div className="flex gap-2 mt-5">
              <button type="button" onClick={() => setOpen(false)} className="btn-ghost h-9 flex-1" data-testid="cp-cancel">Cancel</button>
              <button type="submit" disabled={busy || !cur || nw.length < 6} className="btn-primary h-9 flex-1" data-testid="cp-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update"}</button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
